export const SETTINGS_GET_MEMBERSHIP_TYPES = 'SETTINGS_GET_MEMBERSHIP_TYPES';
export const SETTINGS_GET_MEMBERSHIP_TYPES_SUCCESS = 'SETTINGS_GET_MEMBERSHIP_TYPES_SUCCESS';
export const SETTINGS_UPDATE_LOCALE = 'SETTINGS_UPDATE_LOCALE';
